import { render, staticRenderFns } from "./upload-templates.vue?vue&type=template&id=c797297e&scoped=true&"
import script from "./upload-templates.vue?vue&type=script&lang=js&"
export * from "./upload-templates.vue?vue&type=script&lang=js&"
import style0 from "./upload-templates.vue?vue&type=style&index=0&id=c797297e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c797297e",
  null
  
)

export default component.exports